/**
 * Centralised, typed access to build-time configuration.
 * Everything lives behind the same-origin Apache edge (no CORS):
 *   /api -> WildFly (context /api). El backend wrapea Keycloak, por lo que el
 *   navegador solo necesita conocer el API (aquí no hay URL de IAM).
 */
export const env = {
  apiBase: import.meta.env.VITE_API_BASE ?? '/api',
  defaultTenant: import.meta.env.VITE_DEFAULT_TENANT ?? 'pozuelo',
  // 'fixed' = siempre defaultTenant (host de ENTORNO, p.ej. ambulancias-desa.*).
  // 'subdomain' = primer label del host como tenant (instalación por subdominio).
  tenantMode: (import.meta.env.VITE_TENANT_MODE ?? 'fixed') as 'fixed' | 'subdomain',
  authMode: (import.meta.env.VITE_AUTH_MODE ?? 'backend') as 'backend' | 'mock',
} as const;
